import type { ChatMessage } from '@lemontaigu/chat';
import { receptionText } from './logic.js';

// Shared presentational bits between the live dashboard (Reception.tsx) and
// the history browse (History.tsx) — same message bubbles, same language
// badge, so the two views read identically to staff.

export const LANG_LABELS: Record<string, string> = { fr: 'FR', en: 'EN', es: 'ES', de: 'DE' };

const SENDER_LABELS: Record<ChatMessage['sender'], string> = {
  guest: 'Client',
  staff: 'Réception',
  ai: 'Assistant',
};

export function fmtTime(iso: string): string {
  const d = new Date(iso);
  const date = d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' });
  const time = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  return `${date} ${time}`;
}

export function MessageList({
  messages,
  flaggedIds,
  onToggleFlag,
}: {
  messages: ChatMessage[];
  /** AI messages flagged « Réponse incorrecte » (C7 — chat_ai_feedback). */
  flaggedIds?: Set<number>;
  /** When provided, AI bubbles get the flag/unflag action (live view only). */
  onToggleFlag?: (message: ChatMessage) => void;
}) {
  return (
    <>
      {messages.map((m) => {
        const flagged = m.sender === 'ai' && (flaggedIds?.has(m.id) ?? false);
        return (
          <div key={m.id} className={`msg msg--${m.sender} ${flagged ? 'is-flagged' : ''}`}>
            <span className="msg-sender">
              {SENDER_LABELS[m.sender]}
              <span className="msg-time">{fmtTime(m.createdAt)}</span>
              {flagged && <span className="msg-flagged-badge">réponse signalée</span>}
            </span>
            <p className="msg-body">{receptionText(m)}</p>
            {m.bodyFr && m.body !== m.bodyFr && (
              <p className="msg-original">
                {LANG_LABELS[m.lang]} : {m.body}
              </p>
            )}
            {m.sender === 'ai' && onToggleFlag && (
              <button
                className="msg-flag-btn"
                title="Signaler cette réponse de l’assistant comme incorrecte — elle alimentera la revue de la base de connaissances"
                onClick={() => onToggleFlag(m)}
              >
                {flagged ? 'Retirer le signalement' : 'Réponse incorrecte'}
              </button>
            )}
          </div>
        );
      })}
    </>
  );
}
